import { useEffect } from 'react';

import { browserMetrics } from '@atlassian/browser-metrics';

import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { withTransparentErrorBoundary } from '@confluence/error-boundary/entry-points/withErrorBoundary.ts';

import { isInitial } from './utils/index.ts';

type PageLoadMarkFMPProps = {
	timestamp?: number;
};

/**
 * This component allows to mark customized FMP metric on page-load event.
 */
const Bm3PageLoadMarkFMPComponent = ({ timestamp }: PageLoadMarkFMPProps) => {
	const pageLoadMetric = browserMetrics.getPageLoadMetric();

	useEffect(() => {
		if (typeof timestamp === 'number') {
			pageLoadMetric.markFMP(timestamp);
		} else {
			pageLoadMetric.markFMP();
			try {
				performance.mark('browser-metric.fmp');
				performance.measure(
					'browser-metric:fmp',
					isInitial() ? undefined : 'browser-metric.start',
					'browser-metric.fmp',
				);
				// eslint-disable-next-line no-unused-vars
			} catch (e) {
				// Suppress error when performance API failed.
				// Note: in MicrosoftEdge version 18 and prior, performance.measure(name, startMark, endMark) API will throw SyntaxError if startMark is undefined.
				// That's why wrap with try catch statement.
			}
		}
	}, [timestamp, pageLoadMetric]);

	return null;
};

/**
 * @deprecated This is the legacy BM3 implementation. Use `PageLoadMarkFMP` from
 * `@confluence/browser-metrics/entry-points/PageLoadMarkFMP` instead, which routes
 * through the interop layer and gates on `confluence_fe_deprecate_bm3`.
 */
export const Bm3PageLoadMarkFMP = withTransparentErrorBoundary({
	attribution: Attribution.BACKBONE,
})(Bm3PageLoadMarkFMPComponent);
